import { Send, PhoneCall, ClipboardCheck, Camera, Rocket } from "lucide-react";

const STEPS = [
  {
    icon: Send,
    title: "Vous nous écrivez",
    detail: "Formulaire ou téléphone, choisissez le canal qui vous convient.",
    when: "J0",
  },
  {
    icon: PhoneCall,
    title: "Nous vous rappelons",
    detail:
      "Un City Manager local vous contacte sous 24 h ouvrées pour qualifier votre projet.",
    when: "J+1",
  },
  {
    icon: ClipboardCheck,
    title: "Étude personnalisée",
    detail:
      "Simulation chiffrée + plan d'optimisation envoyés par email, gratuit, sans engagement.",
    when: "J+3",
  },
  {
    icon: Camera,
    title: "Visite & shooting",
    detail:
      "Si vous validez, visite du bien + shooting photo professionnel à votre convenance.",
    when: "J+7",
  },
  {
    icon: Rocket,
    title: "Mise en location",
    detail:
      "Annonces multidiffusées (Airbnb · Booking · Vrbo) en moins de 48h. Vous encaissez.",
    when: "J+10",
  },
];

const ContactNextSteps = () => (
  <section
    className="py-20 lg:py-24 bg-cream relative overflow-hidden"
    data-testid="contact-next-steps"
  >
    {/* Decorative orb */}
    <div
      aria-hidden="true"
      className="absolute -top-20 -right-32 w-[420px] h-[420px] rounded-full pointer-events-none opacity-50"
      style={{
        background:
          "radial-gradient(circle, rgba(197,138,63,0.16) 0%, transparent 65%)",
      }}
    />

    <div className="container-tm relative">
      <div className="max-w-3xl mb-12">
        <p className="overline mb-3">Et après ?</p>
        <h2 className="font-serif font-light text-ink text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
          Que se passe-t-il après{" "}
          <em className="text-gold">votre envoi&nbsp;?</em>
        </h2>
        <p className="mt-5 font-sans text-ink/65 text-base leading-relaxed">
          Voici précisément ce qu'il se passe entre le moment où vous nous
          contactez et la mise en location de votre bien. Tout est cadré dans le
          temps : vous savez exactement quand attendre quoi.
        </p>
      </div>

      {/* Timeline */}
      <ol className="grid md:grid-cols-5 gap-6 lg:gap-4 relative">
        {/* Connector line on desktop */}
        <div
          aria-hidden="true"
          className="hidden md:block absolute top-7 left-[10%] right-[10%] h-px bg-gold/30"
        />

        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <li
              key={i}
              data-testid={`next-step-${i}`}
              className="relative flex flex-col items-center text-center"
            >
              {/* Bubble */}
              <div className="relative z-10 w-14 h-14 rounded-full bg-cream border-2 border-gold flex items-center justify-center text-gold shadow-soft mb-5">
                <Icon size={20} strokeWidth={1.6} />
              </div>
              <p className="text-[10px] uppercase tracking-[0.32em] text-gold font-semibold mb-1.5">
                {s.when}
              </p>
              <h3 className="font-serif text-lg text-ink mb-2 leading-snug">
                {s.title}
              </h3>
              <p className="font-sans text-[13px] text-ink/65 leading-relaxed">
                {s.detail}
              </p>
            </li>
          );
        })}
      </ol>

      {/* === Express 48h bubble === */}
      <div
        className="mt-14 lg:mt-16 max-w-3xl mx-auto"
        data-testid="contact-express-48h"
      >
        <div className="relative bg-ink text-cream rounded-3xl p-7 md:p-9 overflow-hidden">
          {/* Decorative ⚡ watermark */}
          <span
            aria-hidden="true"
            className="absolute -top-6 -right-2 font-serif text-gold/15 select-none pointer-events-none"
            style={{ fontSize: "180px", lineHeight: 1 }}
          >
            ⚡
          </span>

          <div className="relative grid md:grid-cols-12 gap-6 items-center">
            <div className="md:col-span-2 flex justify-center md:justify-start">
              <div className="w-16 h-16 rounded-2xl bg-gold/15 text-gold flex items-center justify-center text-3xl">
                ⚡
              </div>
            </div>
            <div className="md:col-span-7 text-center md:text-left">
              <p className="text-[10px] uppercase tracking-[0.32em] text-gold font-semibold mb-2">
                Express · vacances scolaires · imprévu
              </p>
              <h3 className="font-serif italic font-light text-cream text-2xl md:text-3xl leading-tight mb-2">
                Tout peut se faire en{" "}
                <em className="text-gold not-italic">48 heures</em>.
              </h3>
              <p className="font-sans text-cream/75 text-sm md:text-base leading-relaxed">
                Si vous êtes pressé (vacances scolaires, départ imminent,
                propriétaire actuel défaillant), nous condensons le parcours :
                visite, photos, mise en ligne et premières réservations en{" "}
                <strong className="text-cream">2 jours ouvrés maximum</strong>.
                Mentionnez simplement « <em>urgent</em> » dans votre message.
              </p>
            </div>
            <div className="md:col-span-3 flex justify-center md:justify-end">
              <span className="inline-flex items-center gap-2 bg-gold text-ink font-semibold px-5 py-3 rounded-full text-sm shadow-soft">
                Délai : 48 h max
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ContactNextSteps;
